<div class="extra-bonus-dialog">
  <div class="close-icon" fxLayout="row" fxLayoutAlign="end center">
    <app-close-dialog-button [customClass]="'medium'" [position]="true"
      (closeEvent)="closeDialog()"></app-close-dialog-button>
  </div>

  <div class="hero-wrap">
    <img class="hero" [src]="heroSrc" alt="" />
  </div>

  <p class="body" *ngIf="bodyHtml; else plainBody" [innerHTML]="bodyHtml"></p>
  <ng-template #plainBody><p class="body">{{ body }}</p></ng-template>

  <button class="cta" type="button" (click)="claim()">{{ ctaText }}</button>
</div>
